import { supabase } from "@/lib/supabase";

/**
 * Frontend helpers for the "Nearby at this event" beta. All four calls are
 * thin wrappers around Postgres SECURITY DEFINER RPCs — the table itself
 * is never queried directly, so raw coordinates never leave the database.
 *
 *   • presence_heartbeat → upsert lat/lng + visibility
 *   • presence_clear     → hard-delete the row (opt-out / leave)
 *   • nearby_at_event    → sanitised list of nearby attendees + wave state
 *   • wave_at            → one-way wave; returns {mutual} so the UI knows
 *                          whether to deep-link into DMs
 */

export async function presenceHeartbeat(eventId, { lat, lng }) {
  const { data, error } = await supabase.rpc("presence_heartbeat", {
    p_event_id: eventId,
    p_lat: lat,
    p_lng: lng,
  });
  if (error) throw error;
  return !!data; // bool: are we inside the radius?
}

export async function presenceClear(eventId) {
  const { error } = await supabase.rpc("presence_clear", { p_event_id: eventId });
  if (error) throw error;
}

export async function listNearbyAtEvent(eventId) {
  const { data, error } = await supabase.rpc("nearby_at_event", {
    p_event_id: eventId,
  });
  if (error) throw error;
  return data || [];
}

export async function waveAt(eventId, targetUserId) {
  const { data, error } = await supabase.rpc("wave_at", {
    p_event_id: eventId,
    p_target: targetUserId,
  });
  if (error) throw error;
  return { mutual: !!data?.[0]?.mutual };
}
